export enum State {
  Upload,
  Ruler,
  Stomach,
  Cancer,
  Completed
}

export interface Size {
  width: number;
  height: number;
}

export interface Length {
  length: number;
  cm: boolean;
}

export function adjustSize(originalSize: Size, windowWidth: number) {
  const margin = 0.7;
  let scale = originalSize.width / (windowWidth * margin);
  scale = scale < 1 ? 1 : scale;
  return {
    width: originalSize.width / scale,
    height: originalSize.height / scale
  };
}
